export const documentTypes = {
    id_2021_front: 'id_2021_front',
    id_2012_front: 'id_2012_front',
    id_2012_back: 'id_2012_back',
    id_2005_front: 'id_2005_front',
    id_2005_back: 'id_2005_back',
    driving_license: 'driving_license',
    passport_2006: 'passport_2006',
    id_svk_front: 'id_svk_front',
    id_svk_back: 'id_svk_back'
}